export default [
    { value: 'Cable/DSL', text: 'Cable/DSL' },
    { value: 'Cellular', text: 'Cellular' },
    { value: 'Corporate', text: 'Corporate' },
    { value: 'Dialup', text: 'Dialup' },
];
